import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import CustomThemeProvider from "./ui/theme";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { BrowserRouter } from "react-router-dom";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { MsalProvider } from "@azure/msal-react";
import { EventType, PublicClientApplication, } from "@azure/msal-browser";
import { msalConfig } from "./auth-config";
import LocalStorageService from "@application/features/Common/local-storage-service";
import { persistor, store } from "@application/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
const root = ReactDOM.createRoot(document.getElementById("root"));
export const msalInstance = new PublicClientApplication(msalConfig);
msalInstance.initialize().then(() => {
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length) {
        msalInstance.setActiveAccount(accounts[0]);
    }
    msalInstance.addEventCallback((event) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
            const payload = event.payload;
            const account = payload.account;
            msalInstance.setActiveAccount(account);
        }
        else if (event.eventType === EventType.LOGOUT_SUCCESS)
            LocalStorageService.removeAccessToken();
    });
});
root.render(_jsx(LocalizationProvider, { dateAdapter: AdapterDayjs, children: _jsx(I18nextProvider, { i18n: i18n, defaultNS: "translation", children: _jsx(React.StrictMode, { children: _jsx(Provider, { store: store, children: _jsx(PersistGate, { loading: null, persistor: persistor, children: _jsx(BrowserRouter, { children: _jsx(MsalProvider, { instance: msalInstance, children: _jsx(CustomThemeProvider, { children: _jsx(App, {}) }) }) }) }) }) }) }) }));
reportWebVitals();
